import React from "react"
import { Portrait as SDKPortrait } from "@hg/dialog-sdk"
import clsx from "clsx"
import type { PortraitSide } from "@hg/dialog-sdk"
import styles from "./index.module.scss"

interface PortraitComponentProps {
    side: PortraitSide
    characterImages?: Record<string, string>
    emotionImages?: Record<string, Record<string, string>>
    isHighlighted?: boolean
}

export const PortraitComponent: React.FC<PortraitComponentProps> = ({
    side,
    characterImages,
    emotionImages,
    isHighlighted,
}) => {
    const portraitClass = clsx(
        side === "left" ? styles.portraitLeft : styles.portraitRight,
        { [styles.highlighted]: isHighlighted }
    )

    return (
        <SDKPortrait.Root
            side={side}
            className={portraitClass}
            characterImages={characterImages}
            emotionImages={emotionImages}
        >
            <SDKPortrait.Image className={styles.portraitImage} />
            <SDKPortrait.Emotion className={styles.portraitEmotion} />
        </SDKPortrait.Root>
    )
}
